export type ScopeAnchor = {
  startLine: number;
  startColumn: number;
};

export type MemberAccessRule = {
  parentType: string;
  objectField: string;
  propertyField: string;
  tagKind?: string;
};

export const MEMBER_NAME_NODE_TYPES = new Set([
  'identifier',
  'property_identifier',
  'field_identifier',
  'type_identifier',
  'constant',
  'package_identifier',
]);
